module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/xiaohongshu.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/xiaohongshu.png
// module id = 631
// module chunks = 431